/**
 * AI Katalog Optimizer - Shopify Embedded App
 *
 * Uses Polaris Design System for seamless Shopify Admin integration.
 * App Bridge provides session token management for API authentication.
 */

import { AppProvider } from '@shopify/polaris';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import de from '@shopify/polaris/locales/de.json';
import '@shopify/polaris/build/esm/styles.css';

import { AppBridgeProvider } from './providers/AppBridgeProvider';
import { ApiProvider } from './providers/ApiProvider';
import { AppFrame } from './components/AppFrame';
import { DashboardPage } from './pages/Dashboard';
import { ProductsPage } from './pages/Products';
import { OptimizePage } from './pages/Optimize';
import { SettingsPage } from './pages/Settings';

export function App() {
  return (
    <AppProvider i18n={de}>
      <AppBridgeProvider>
        <ApiProvider>
          <BrowserRouter>
            <AppFrame>
              <Routes>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<DashboardPage />} />
                <Route path="/products" element={<ProductsPage />} />
                <Route path="/optimize" element={<OptimizePage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Routes>
            </AppFrame>
          </BrowserRouter>
        </ApiProvider>
      </AppBridgeProvider>
    </AppProvider>
  );
}
